var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.01172C13.7015 6.01172 14 6.3102 14 6.67839C14 6.86248 13.8508 7.01172 13.6667 7.01172H13.5C12.6716 7.01172 12 7.68329 12 8.51172V22.5117C12 23.3401 12.6716 24.0117 13.5 24.0117H19.1972C19.6988 24.0117 20.1671 23.7611 20.4453 23.3438L21.6617 21.5192C21.8367 21.2567 22.2082 21.2199 22.4313 21.443L22.563 21.5747C22.8308 21.8425 22.9243 22.2387 22.8046 22.598L22.3419 23.9861C22.1377 24.5986 21.5645 25.0117 20.9189 25.0117H8.16667C7.79848 25.0117 7.5 24.7132 7.5 24.3451C7.5 24.161 7.64924 24.0117 7.83333 24.0117H8C8.82843 24.0117 9.5 23.3401 9.5 22.5117V8.51172C9.5 7.68329 8.82843 7.01172 8 7.01172H7.83333C7.64924 7.01172 7.5 6.86248 7.5 6.67839C7.5 6.3102 7.79848 6.01172 8.16667 6.01172H13.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatin);
export default __webpack_public_path__ + "static/media/Latin.c31ccdfdc8820c7bc9235bd8ead37a4e.svg";
export { ForwardRef as ReactComponent };